define('model/CompanyModel',['require','lib/model/BaseModel'],function (require) {

	var BaseModel = require('lib/model/BaseModel');
	
	/**
	 * Company info model
	 * 
	 * @class CompanyModel
	 */
	return BaseModel.extend({
		
		url: '/company/',
		
		defaults: {
			description: '',
			name: '',
			login: ''
		}
		
	});
	
});
